export default "<div class=\"custom-margin top-custom\">\n<p>\n  reviews works!\n</p>\n</div>\n"